import React, { Component } from 'react';

import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Layout, Icon, Menu } from 'antd';

import IconSvg from '../../../utils/svg';

import { clearToken, setGlobalInfo, setLocalInfo, setCoachesArray } from './dashboard.actions'
import { goToAddUser } from '../admin/admin.actions'
import { getUserLogged } from '../../App.actions';


import { Navbar, Sidemenu, Content, Footer } from '../../components/index';

import ContentRoutes from '../../../config/route-content';

import './dashboard.css'
import { isEmpty } from '../../../utils/functions';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      trigger: true
    }
    this.toogleTrigger = this.toogleTrigger.bind(this);
  }

  componentDidMount() {
    if (isEmpty(this.props.auth.userLogged)) {
      this.props.getUserLogged()
    }
  }

  toogleTrigger() {
    this.setState({ trigger: !this.state.trigger })
  }

  logout() {
    sessionStorage.clear();
    this.props.clearToken();
  }

  returnAvatarMenu() {
    return (
      <div><Link to='/login' onClick={this.logout}><Icon type='logout' /> Sair</Link></div>
    )
  }

  currentLink() {
    const pathName = window.location.pathname
    if (pathName === '/dashboard/admin/list') {
      return ['4', 'sub2-1']
    }
    if (pathName === '/dashboard/admin/add') {
      return ['4', 'sub2-2']
    }

    if (pathName === '/dashboard/ranking') {
      return ['3']
    }

    if (pathName === '/dashboard/coaches') {
      return ['2']
    }

    if (pathName === '/dashboard/statistics') {
      return ['1']
    }
    return []
  }

  render() {
    const { auth } = this.props;
    return (
      <Layout className='main-wrapper'>

        <Sidemenu collapsed={this.state.trigger}>
          <Menu theme="dark" mode="inline" selectedKeys={this.currentLink()} >

            <Menu.Item key="1">
              <Link to='/dashboard'>
                <IconSvg name='icon-statistic' height={'33px'} />
              </Link>
            </Menu.Item>

            <Menu.Item key="2">
              <Link to='/dashboard/coaches'>
                <IconSvg name='icon-coaches' height={'33px'} />
              </Link>
            </Menu.Item>
            
            <Menu.Item key="3">
              <Link to='/dashboard/ranking'>
                <IconSvg name='icon-ranking' height={'33px'} />
              </Link>
            </Menu.Item>

            {/* <Menu.Item key="4">
              <Link to='/dashboard/admin/list'>
                <IconSvg name='icon-user-menu' height={'33px'} />
              </Link>
            </Menu.Item> */}
          </Menu>

        </Sidemenu>

        <Layout className={'dashboard-content'}>
          <Navbar
            menu={this.returnAvatarMenu()}
            className={'hasSider'}
            loadingtextLogo={auth.loading}
            textLogo={`${auth.userLogged.name} - ${auth.userLogged.branch}`}
            collapsed={this.state.trigger}
            triggerFunc={this.toogleTrigger} />
          <Content>
            <ContentRoutes />
          </Content>
          <Footer>
            Coach Admin ©2018
                </Footer>
        </Layout>
      </Layout>
    );
  }
}

const mapStateToProps = ({ auth }) => ({
  auth: auth
});

const mapDispatchToProps = dispatch => bindActionCreators({ clearToken, getUserLogged, setGlobalInfo, setLocalInfo, setCoachesArray, goToAddUser }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)


// WEBPACK FOOTER //
// ./src/App/containers/dashboard/dashboard.js